export default {
  text: {
    en: 'Did you mean <span class="brandColor">...@<b>{domain}</b></span>?',
  },
  button: {
    en: 'Yes',
  },
}
